<template>
    <div class="text-grey-dark">
        <inertia-link
            :href="href"
            class="text-grey-dark">
            <div class="row space-y-4" :class="{'lg:space-y-0': split}">
                <div class="col-full" :class="{'lg:col-1/2': split}">
                    <PostThumbnail :post="post"/>
                </div>
                <div class="col-full" :class="{'lg:col-1/2': split}">
                    <h4 class="font-semibold text-lg leading-tight mb-4">
                        {{ post.title }}
                        <LeftHandedIcon v-if="post.left_handed"></LeftHandedIcon>
                    </h4>
                    <div class="text-sm" v-html="post.summary"/>
                    <div v-if="hasQuiz" class="mt-4">
                        <button
                            type="button"
                            @click.prevent="goToQuiz"
                            class="inline-block bg-red-600 hover:text-white hover:bg-red-400 text-white font-semibold py-2 px-4 rounded transition-colors">
                            Test your knowledge
                        </button>
                    </div>
                </div>
            </div>
        </inertia-link>
    </div>
</template>

<script>

import PostThumbnail from "@app/Shared/Components/PostThumbnail";
import LeftHandedIcon from "@app/Shared/Components/LeftHandedIcon";
import {PostType} from "@admin/Lib/Enums";

export default {

    name: "PostTile",

    props: {
        post: {
            type: Object,
            required: true,
        },
        split: {
            type: Boolean,
            default: true
        }
    },

    components: {
        PostThumbnail,
        LeftHandedIcon,
    },

    computed: {
        hasQuiz() {
            if (!this.post.publish_quiz) {
                return false;
            }
            return (this.post.questions_count > 0) || (this.post.questions && this.post.questions.length > 0);
        },
        href() {
            switch (this.post.type) {
                case PostType.Tutorial:
                    return `/tutorial/${this.post.id}`
                case PostType.CaseReport:
                    return `/case-report/${this.post.id}`
            }
        },
    },
    methods: {
        goToQuiz() {
            window.location.href = `${this.href}?scroll=quiz`;
        }
    }
};

</script>
